import { formatCurrency } from "@/lib/utils";

interface OrderItemProps {
	image: string;
	name: string;
	quantity: number;
	price: string | number;
}

export function OrderItem({ image, name, price, quantity }: OrderItemProps) {
	return (
		<div className="flex items-start gap-4 rounded-lg border p-4">
			<div className="relative h-20 w-20 overflow-hidden rounded-lg bg-gray-50">
				<img
					src={image || "/placeholder.svg"}
					alt={name}
					width={80}
					height={80}
					className="h-full w-full object-cover"
				/>
			</div>
			<div className="flex-1">
				<h3 className="font-medium capitalize">{name}</h3>
				<p className="text-lg font-semibold">{formatCurrency(Number(price), "NGN")}</p>
				<p className="text-sm text-gray-500">
					Qty:
					{quantity}
				</p>
			</div>
		</div>
	);
}
